<template>
    <input type="text" ref="input" v-bind:value="value | date" v-on:keydown="forceDate" />
</template>

<script>
import $ from "jquery";

require("@/../public/assets/plugins/bootstrap-datepicker/bootstrap-datepicker.min");

export default {
    props: ["value"],
    methods: {
        forceDate(event) {
            let authorizedSpecialKeys = ["Backspace","Delete","Enter","ArrowLeft","ArrowRight","ArrowDown","ArrowUp","-"]
            if((event.key >= 0 && event.key <= 9) || authorizedSpecialKeys.includes(event.key) ) {
                return true;
            }

            event.preventDefault();
        }
    },
    mounted: function () {
        this.$nextTick(() => {
            var vm = this;
            $(this.$el)
                .datepicker({
                    autoclose: true,
                    todayHighlight: true,
                    format: "dd-mm-yyyy"
                })
                .on("changeDate", function (value) {
                    let localDate = new Date(
                        value.date.getTime() +
                        value.date.getTimezoneOffset() * -1 * 60 * 1000
                    );

                    vm.$emit("input", localDate.toISOString());
            });
        });
    }
};
</script>
